/**
 * Generated by @openapi-codegen
 *
 * @version v1
 */
import * as reactQuery from 'react-query';
import { useDeploymentsContext, DeploymentsContext } from './deploymentsContext';
import type * as Fetcher from './deploymentsFetcher';
import { deploymentsFetch } from './deploymentsFetcher';
import type * as Schemas from './deploymentsSchemas';

export type GetRegionsPathParams = {
  /*
   * realm name (not id!)
   */
  realm: string;
};

export type GetRegionsQueryParams = {
  /*
   * Set to true for regions that support shared hosting
   */
  shared?: boolean;
};

export type GetRegionsError = Fetcher.ErrorWrapper<undefined>;

export type GetRegionsResponse = Schemas.RegionRepresentation[];

export type GetRegionsVariables = {
  pathParams: GetRegionsPathParams;
  queryParams?: GetRegionsQueryParams;
} & DeploymentsContext['fetcherOptions'];

export const fetchGetRegions = (variables: GetRegionsVariables) =>
  deploymentsFetch<GetRegionsResponse, GetRegionsError, undefined, {}, GetRegionsQueryParams, GetRegionsPathParams>({
    url: '/{realm}/clusters/regions',
    method: 'get',
    ...variables,
  });

export const useGetRegions = (
  variables: GetRegionsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<GetRegionsResponse, GetRegionsError, GetRegionsResponse>,
    'queryKey' | 'queryFn'
  >
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useDeploymentsContext(options);
  return reactQuery.useQuery<GetRegionsResponse, GetRegionsError, GetRegionsResponse>(
    queryKeyFn({ path: '/{realm}/clusters/regions', operationId: 'getRegions', variables }),
    () => fetchGetRegions({ ...fetcherOptions, ...variables }),
    {
      ...options,
      ...queryOptions,
    }
  );
};

export type GetClustersPathParams = {
  /*
   * realm name (not id!)
   */
  realm: string;
};

export type GetClustersError = Fetcher.ErrorWrapper<undefined>;

export type GetClustersResponse = Schemas.ClusterRepresentation[];

export type GetClustersVariables = {
  pathParams: GetClustersPathParams;
} & DeploymentsContext['fetcherOptions'];

export const fetchGetClusters = (variables: GetClustersVariables) =>
  deploymentsFetch<GetClustersResponse, GetClustersError, undefined, {}, {}, GetClustersPathParams>({
    url: '/{realm}/clusters',
    method: 'get',
    ...variables,
  });

export const useGetClusters = (
  variables: GetClustersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<GetClustersResponse, GetClustersError, GetClustersResponse>,
    'queryKey' | 'queryFn'
  >
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useDeploymentsContext(options);
  return reactQuery.useQuery<GetClustersResponse, GetClustersError, GetClustersResponse>(
    queryKeyFn({ path: '/{realm}/clusters', operationId: 'getClusters', variables }),
    () => fetchGetClusters({ ...fetcherOptions, ...variables }),
    {
      ...options,
      ...queryOptions,
    }
  );
};

export type CreateClusterPathParams = {
  /*
   * realm name (not id!)
   */
  realm: string;
};

export type CreateClusterError = Fetcher.ErrorWrapper<undefined>;

export type CreateClusterVariables = {
  body?: Schemas.ClusterRequestRepresentation;
  pathParams: CreateClusterPathParams;
} & DeploymentsContext['fetcherOptions'];

export const fetchCreateCluster = (variables: CreateClusterVariables) =>
  deploymentsFetch<
    Schemas.RedirectLinkRepresentation,
    CreateClusterError,
    Schemas.ClusterRequestRepresentation,
    {},
    {},
    CreateClusterPathParams
  >({ url: '/{realm}/clusters', method: 'post', ...variables });

export const useCreateCluster = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.RedirectLinkRepresentation, CreateClusterError, CreateClusterVariables>,
    'mutationFn'
  >
) => {
  const { fetcherOptions } = useDeploymentsContext();
  return reactQuery.useMutation<Schemas.RedirectLinkRepresentation, CreateClusterError, CreateClusterVariables>(
    (variables: CreateClusterVariables) => fetchCreateCluster({ ...fetcherOptions, ...variables }),
    options
  );
};

export type GetClusterByIdPathParams = {
  /*
   * realm name (not id!)
   */
  realm: string;
  /*
   * cluster id
   */
  clusterId: string;
};

export type GetClusterByIdError = Fetcher.ErrorWrapper<undefined>;

export type GetClusterByIdVariables = {
  pathParams: GetClusterByIdPathParams;
} & DeploymentsContext['fetcherOptions'];

export const fetchGetClusterById = (variables: GetClusterByIdVariables) =>
  deploymentsFetch<Schemas.ClusterRepresentation, GetClusterByIdError, undefined, {}, {}, GetClusterByIdPathParams>({
    url: '/{realm}/clusters/{clusterId}',
    method: 'get',
    ...variables,
  });

export const useGetClusterById = (
  variables: GetClusterByIdVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.ClusterRepresentation, GetClusterByIdError, Schemas.ClusterRepresentation>,
    'queryKey' | 'queryFn'
  >
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useDeploymentsContext(options);
  return reactQuery.useQuery<Schemas.ClusterRepresentation, GetClusterByIdError, Schemas.ClusterRepresentation>(
    queryKeyFn({ path: '/{realm}/clusters/{clusterId}', operationId: 'getClusterById', variables }),
    () => fetchGetClusterById({ ...fetcherOptions, ...variables }),
    {
      ...options,
      ...queryOptions,
    }
  );
};

export type UpdateClusterByIdPathParams = {
  /*
   * realm name (not id!)
   */
  realm: string;
  /*
   * cluster id
   */
  clusterId: string;
};

export type UpdateClusterByIdError = Fetcher.ErrorWrapper<undefined>;

export type UpdateClusterByIdVariables = {
  body: Schemas.ClusterRepresentation;
  pathParams: UpdateClusterByIdPathParams;
} & DeploymentsContext['fetcherOptions'];

export const fetchUpdateClusterById = (variables: UpdateClusterByIdVariables) =>
  deploymentsFetch<
    undefined,
    UpdateClusterByIdError,
    Schemas.ClusterRepresentation,
    {},
    {},
    UpdateClusterByIdPathParams
  >({ url: '/{realm}/clusters/{clusterId}', method: 'put', ...variables });

export const useUpdateClusterById = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, UpdateClusterByIdError, UpdateClusterByIdVariables>,
    'mutationFn'
  >
) => {
  const { fetcherOptions } = useDeploymentsContext();
  return reactQuery.useMutation<undefined, UpdateClusterByIdError, UpdateClusterByIdVariables>(
    (variables: UpdateClusterByIdVariables) => fetchUpdateClusterById({ ...fetcherOptions, ...variables }),
    options
  );
};

export type DeleteClusterByIdPathParams = {
  /*
   * realm name (not id!)
   */
  realm: string;
  /*
   * cluster id
   */
  clusterId: string;
};

export type DeleteClusterByIdError = Fetcher.ErrorWrapper<undefined>;

export type DeleteClusterByIdVariables = {
  pathParams: DeleteClusterByIdPathParams;
} & DeploymentsContext['fetcherOptions'];

export const fetchDeleteClusterById = (variables: DeleteClusterByIdVariables) =>
  deploymentsFetch<undefined, DeleteClusterByIdError, undefined, {}, {}, DeleteClusterByIdPathParams>({
    url: '/{realm}/clusters/{clusterId}',
    method: 'delete',
    ...variables,
  });

export const useDeleteClusterById = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, DeleteClusterByIdError, DeleteClusterByIdVariables>,
    'mutationFn'
  >
) => {
  const { fetcherOptions } = useDeploymentsContext();
  return reactQuery.useMutation<undefined, DeleteClusterByIdError, DeleteClusterByIdVariables>(
    (variables: DeleteClusterByIdVariables) => fetchDeleteClusterById({ ...fetcherOptions, ...variables }),
    options
  );
};

export type GetDeploymentsForClusterPathParams = {
  /*
   * realm name (not id!)
   */
  realm: string;
  /*
   * cluster id
   */
  clusterId: string;
};

export type GetDeploymentsForClusterError = Fetcher.ErrorWrapper<undefined>;

export type GetDeploymentsForClusterResponse = Schemas.DeploymentRepresentation[];

export type GetDeploymentsForClusterVariables = {
  pathParams: GetDeploymentsForClusterPathParams;
} & DeploymentsContext['fetcherOptions'];

export const fetchGetDeploymentsForCluster = (variables: GetDeploymentsForClusterVariables) =>
  deploymentsFetch<
    GetDeploymentsForClusterResponse,
    GetDeploymentsForClusterError,
    undefined,
    {},
    {},
    GetDeploymentsForClusterPathParams
  >({ url: '/{realm}/clusters/{clusterId}/deployments', method: 'get', ...variables });

export const useGetDeploymentsForCluster = (
  variables: GetDeploymentsForClusterVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetDeploymentsForClusterResponse,
      GetDeploymentsForClusterError,
      GetDeploymentsForClusterResponse
    >,
    'queryKey' | 'queryFn'
  >
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useDeploymentsContext(options);
  return reactQuery.useQuery<
    GetDeploymentsForClusterResponse,
    GetDeploymentsForClusterError,
    GetDeploymentsForClusterResponse
  >(
    queryKeyFn({
      path: '/{realm}/clusters/{clusterId}/deployments',
      operationId: 'getDeploymentsForCluster',
      variables,
    }),
    () => fetchGetDeploymentsForCluster({ ...fetcherOptions, ...variables }),
    {
      ...options,
      ...queryOptions,
    }
  );
};

export type CreateDedicatedDeploymentPathParams = {
  /*
   * realm name (not id!)
   */
  realm: string;
  /*
   * cluster id
   */
  clusterId: string;
};

export type CreateDedicatedDeploymentError = Fetcher.ErrorWrapper<{
  status: 409;
  payload: Record<string, any>;
}>;

export type CreateDedicatedDeploymentVariables = {
  body: Schemas.ClusterDeploymentRequest;
  pathParams: CreateDedicatedDeploymentPathParams;
} & DeploymentsContext['fetcherOptions'];

export const fetchCreateDedicatedDeployment = (variables: CreateDedicatedDeploymentVariables) =>
  deploymentsFetch<
    undefined,
    CreateDedicatedDeploymentError,
    Schemas.ClusterDeploymentRequest,
    {},
    {},
    CreateDedicatedDeploymentPathParams
  >({ url: '/{realm}/clusters/{clusterId}/deployments', method: 'post', ...variables });

export const useCreateDedicatedDeployment = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, CreateDedicatedDeploymentError, CreateDedicatedDeploymentVariables>,
    'mutationFn'
  >
) => {
  const { fetcherOptions } = useDeploymentsContext();
  return reactQuery.useMutation<undefined, CreateDedicatedDeploymentError, CreateDedicatedDeploymentVariables>(
    (variables: CreateDedicatedDeploymentVariables) =>
      fetchCreateDedicatedDeployment({ ...fetcherOptions, ...variables }),
    options
  );
};

export type GetMetricsForClusterPathParams = {
  /*
   * realm name (not id!)
   */
  realm: string;
  /*
   * cluster id
   */
  clusterId: string;
};

export type GetMetricsForClusterError = Fetcher.ErrorWrapper<undefined>;

export type GetMetricsForClusterVariables = {
  pathParams: GetMetricsForClusterPathParams;
} & DeploymentsContext['fetcherOptions'];

export const fetchGetMetricsForCluster = (variables: GetMetricsForClusterVariables) =>
  deploymentsFetch<
    Schemas.MetricsRepresentation,
    GetMetricsForClusterError,
    undefined,
    {},
    {},
    GetMetricsForClusterPathParams
  >({ url: '/{realm}/clusters/{clusterId}/metrics', method: 'get', ...variables });

export const useGetMetricsForCluster = (
  variables: GetMetricsForClusterVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.MetricsRepresentation, GetMetricsForClusterError, Schemas.MetricsRepresentation>,
    'queryKey' | 'queryFn'
  >
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useDeploymentsContext(options);
  return reactQuery.useQuery<Schemas.MetricsRepresentation, GetMetricsForClusterError, Schemas.MetricsRepresentation>(
    queryKeyFn({ path: '/{realm}/clusters/{clusterId}/metrics', operationId: 'getMetricsForCluster', variables }),
    () => fetchGetMetricsForCluster({ ...fetcherOptions, ...variables }),
    {
      ...options,
      ...queryOptions,
    }
  );
};

export type GetSubscriptionInfoPathParams = {
  /*
   * realm name (not id!)
   */
  realm: string;
  /*
   * cluster id
   */
  clusterId: string;
};

export type GetSubscriptionInfoError = Fetcher.ErrorWrapper<undefined>;

export type GetSubscriptionInfoVariables = {
  pathParams: GetSubscriptionInfoPathParams;
} & DeploymentsContext['fetcherOptions'];

export const fetchGetSubscriptionInfo = (variables: GetSubscriptionInfoVariables) =>
  deploymentsFetch<
    Schemas.SubscriptionRepresentation,
    GetSubscriptionInfoError,
    undefined,
    {},
    {},
    GetSubscriptionInfoPathParams
  >({ url: '/{realm}/clusters/{clusterId}/billing', method: 'get', ...variables });

export const useGetSubscriptionInfo = (
  variables: GetSubscriptionInfoVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SubscriptionRepresentation,
      GetSubscriptionInfoError,
      Schemas.SubscriptionRepresentation
    >,
    'queryKey' | 'queryFn'
  >
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useDeploymentsContext(options);
  return reactQuery.useQuery<
    Schemas.SubscriptionRepresentation,
    GetSubscriptionInfoError,
    Schemas.SubscriptionRepresentation
  >(
    queryKeyFn({ path: '/{realm}/clusters/{clusterId}/billing', operationId: 'getSubscriptionInfo', variables }),
    () => fetchGetSubscriptionInfo({ ...fetcherOptions, ...variables }),
    {
      ...options,
      ...queryOptions,
    }
  );
};

export type CreateBillingSessionPathParams = {
  /*
   * realm name (not id!)
   */
  realm: string;
  /*
   * cluster id
   */
  clusterId: string;
};

export type CreateBillingSessionError = Fetcher.ErrorWrapper<undefined>;

export type CreateBillingSessionVariables = {
  pathParams: CreateBillingSessionPathParams;
} & DeploymentsContext['fetcherOptions'];

export const fetchCreateBillingSession = (variables: CreateBillingSessionVariables) =>
  deploymentsFetch<
    Schemas.RedirectLinkRepresentation,
    CreateBillingSessionError,
    undefined,
    {},
    {},
    CreateBillingSessionPathParams
  >({ url: '/{realm}/clusters/{clusterId}/billing', method: 'post', ...variables });

export const useCreateBillingSession = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.RedirectLinkRepresentation,
      CreateBillingSessionError,
      CreateBillingSessionVariables
    >,
    'mutationFn'
  >
) => {
  const { fetcherOptions } = useDeploymentsContext();
  return reactQuery.useMutation<
    Schemas.RedirectLinkRepresentation,
    CreateBillingSessionError,
    CreateBillingSessionVariables
  >(
    (variables: CreateBillingSessionVariables) => fetchCreateBillingSession({ ...fetcherOptions, ...variables }),
    options
  );
};

export type GetDeploymentsPathParams = {
  /*
   * realm name (not id!)
   */
  realm: string;
};

export type GetDeploymentsError = Fetcher.ErrorWrapper<undefined>;

export type GetDeploymentsResponse = Schemas.DeploymentRepresentation[];

export type GetDeploymentsVariables = {
  pathParams: GetDeploymentsPathParams;
} & DeploymentsContext['fetcherOptions'];

export const fetchGetDeployments = (variables: GetDeploymentsVariables) =>
  deploymentsFetch<GetDeploymentsResponse, GetDeploymentsError, undefined, {}, {}, GetDeploymentsPathParams>({
    url: '/{realm}/deployments',
    method: 'get',
    ...variables,
  });

export const useGetDeployments = (
  variables: GetDeploymentsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<GetDeploymentsResponse, GetDeploymentsError, GetDeploymentsResponse>,
    'queryKey' | 'queryFn'
  >
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useDeploymentsContext(options);
  return reactQuery.useQuery<GetDeploymentsResponse, GetDeploymentsError, GetDeploymentsResponse>(
    queryKeyFn({ path: '/{realm}/deployments', operationId: 'getDeployments', variables }),
    () => fetchGetDeployments({ ...fetcherOptions, ...variables }),
    {
      ...options,
      ...queryOptions,
    }
  );
};

export type CreateDeploymentPathParams = {
  /*
   * realm name (not id!)
   */
  realm: string;
};

export type CreateDeploymentError = Fetcher.ErrorWrapper<undefined>;

export type CreateDeploymentVariables = {
  body: Schemas.DeploymentRepresentation;
  pathParams: CreateDeploymentPathParams;
} & DeploymentsContext['fetcherOptions'];

export const fetchCreateDeployment = (variables: CreateDeploymentVariables) =>
  deploymentsFetch<
    undefined,
    CreateDeploymentError,
    Schemas.DeploymentRepresentation,
    {},
    {},
    CreateDeploymentPathParams
  >({ url: '/{realm}/deployments', method: 'post', ...variables });

export const useCreateDeployment = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, CreateDeploymentError, CreateDeploymentVariables>,
    'mutationFn'
  >
) => {
  const { fetcherOptions } = useDeploymentsContext();
  return reactQuery.useMutation<undefined, CreateDeploymentError, CreateDeploymentVariables>(
    (variables: CreateDeploymentVariables) => fetchCreateDeployment({ ...fetcherOptions, ...variables }),
    options
  );
};

export type CheckDeploymentNameAvailablePathParams = {
  /*
   * realm name (not id!)
   */
  realm: string;
};

export type CheckDeploymentNameAvailableQueryParams = {
  /*
   * deployment name
   */
  name: string;
};

export type CheckDeploymentNameAvailableError = Fetcher.ErrorWrapper<undefined>;

export type CheckDeploymentNameAvailableVariables = {
  pathParams: CheckDeploymentNameAvailablePathParams;
  queryParams: CheckDeploymentNameAvailableQueryParams;
} & DeploymentsContext['fetcherOptions'];

export const fetchCheckDeploymentNameAvailable = (variables: CheckDeploymentNameAvailableVariables) =>
  deploymentsFetch<
    Record<string, any>,
    CheckDeploymentNameAvailableError,
    undefined,
    {},
    CheckDeploymentNameAvailableQueryParams,
    CheckDeploymentNameAvailablePathParams
  >({ url: '/{realm}/deployments/name-available', method: 'get', ...variables });

export const useCheckDeploymentNameAvailable = (
  variables: CheckDeploymentNameAvailableVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Record<string, any>, CheckDeploymentNameAvailableError, Record<string, any>>,
    'queryKey' | 'queryFn'
  >
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useDeploymentsContext(options);
  return reactQuery.useQuery<Record<string, any>, CheckDeploymentNameAvailableError, Record<string, any>>(
    queryKeyFn({ path: '/{realm}/deployments/name-available', operationId: 'checkDeploymentNameAvailable', variables }),
    () => fetchCheckDeploymentNameAvailable({ ...fetcherOptions, ...variables }),
    {
      ...options,
      ...queryOptions,
    }
  );
};

export type CheckClusterNameAvailablePathParams = {
  /*
   * realm name (not id!)
   */
  realm: string;
};

export type CheckClusterNameAvailableQueryParams = {
  /*
   * cluster name
   */
  name: string;
};

export type CheckClusterNameAvailableError = Fetcher.ErrorWrapper<undefined>;

export type CheckClusterNameAvailableVariables = {
  pathParams: CheckClusterNameAvailablePathParams;
  queryParams: CheckClusterNameAvailableQueryParams;
} & DeploymentsContext['fetcherOptions'];

export const fetchCheckClusterNameAvailable = (variables: CheckClusterNameAvailableVariables) =>
  deploymentsFetch<
    Record<string, any>,
    CheckClusterNameAvailableError,
    undefined,
    {},
    CheckClusterNameAvailableQueryParams,
    CheckClusterNameAvailablePathParams
  >({ url: '/{realm}/clusters/name-available', method: 'get', ...variables });

export const useCheckClusterNameAvailable = (
  variables: CheckClusterNameAvailableVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Record<string, any>, CheckClusterNameAvailableError, Record<string, any>>,
    'queryKey' | 'queryFn'
  >
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useDeploymentsContext(options);
  return reactQuery.useQuery<Record<string, any>, CheckClusterNameAvailableError, Record<string, any>>(
    queryKeyFn({ path: '/{realm}/clusters/name-available', operationId: 'checkClusterNameAvailable', variables }),
    () => fetchCheckClusterNameAvailable({ ...fetcherOptions, ...variables }),
    {
      ...options,
      ...queryOptions,
    }
  );
};

export type CheckDedicatedClusterDeploymentNameAvailablePathParams = {
  /*
   * realm name (not id!)
   */
  realm: string;
  /*
   * cluster id
   */
  clusterId: string;
};

export type CheckDedicatedClusterDeploymentNameAvailableQueryParams = {
  /*
   * deployment name
   */
  name: string;
};

export type CheckDedicatedClusterDeploymentNameAvailableError = Fetcher.ErrorWrapper<undefined>;

export type CheckDedicatedClusterDeploymentNameAvailableVariables = {
  pathParams: CheckDedicatedClusterDeploymentNameAvailablePathParams;
  queryParams: CheckDedicatedClusterDeploymentNameAvailableQueryParams;
} & DeploymentsContext['fetcherOptions'];

export const fetchCheckDedicatedClusterDeploymentNameAvailable = (
  variables: CheckDedicatedClusterDeploymentNameAvailableVariables
) =>
  deploymentsFetch<
    Record<string, any>,
    CheckDedicatedClusterDeploymentNameAvailableError,
    undefined,
    {},
    CheckDedicatedClusterDeploymentNameAvailableQueryParams,
    CheckDedicatedClusterDeploymentNameAvailablePathParams
  >({ url: '/{realm}/clusters/{clusterId}/deployments/name-available', method: 'get', ...variables });

export const useCheckDedicatedClusterDeploymentNameAvailable = (
  variables: CheckDedicatedClusterDeploymentNameAvailableVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Record<string, any>,
      CheckDedicatedClusterDeploymentNameAvailableError,
      Record<string, any>
    >,
    'queryKey' | 'queryFn'
  >
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useDeploymentsContext(options);
  return reactQuery.useQuery<
    Record<string, any>,
    CheckDedicatedClusterDeploymentNameAvailableError,
    Record<string, any>
  >(
    queryKeyFn({
      path: '/{realm}/clusters/{clusterId}/deployments/name-available',
      operationId: 'checkDedicatedClusterDeploymentNameAvailable',
      variables,
    }),
    () => fetchCheckDedicatedClusterDeploymentNameAvailable({ ...fetcherOptions, ...variables }),
    {
      ...options,
      ...queryOptions,
    }
  );
};

export type GetDeploymentByIdPathParams = {
  /*
   * realm name (not id!)
   */
  realm: string;
  /*
   * deployment id
   */
  deploymentId: string;
};

export type GetDeploymentByIdError = Fetcher.ErrorWrapper<undefined>;

export type GetDeploymentByIdVariables = {
  pathParams: GetDeploymentByIdPathParams;
} & DeploymentsContext['fetcherOptions'];

export const fetchGetDeploymentById = (variables: GetDeploymentByIdVariables) =>
  deploymentsFetch<
    Schemas.DeploymentRepresentation,
    GetDeploymentByIdError,
    undefined,
    {},
    {},
    GetDeploymentByIdPathParams
  >({ url: '/{realm}/deployments/{deploymentId}', method: 'get', ...variables });

export const useGetDeploymentById = (
  variables: GetDeploymentByIdVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DeploymentRepresentation,
      GetDeploymentByIdError,
      Schemas.DeploymentRepresentation
    >,
    'queryKey' | 'queryFn'
  >
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useDeploymentsContext(options);
  return reactQuery.useQuery<
    Schemas.DeploymentRepresentation,
    GetDeploymentByIdError,
    Schemas.DeploymentRepresentation
  >(
    queryKeyFn({ path: '/{realm}/deployments/{deploymentId}', operationId: 'getDeploymentById', variables }),
    () => fetchGetDeploymentById({ ...fetcherOptions, ...variables }),
    {
      ...options,
      ...queryOptions,
    }
  );
};

export type UpdateDeploymentByIdPathParams = {
  /*
   * realm name (not id!)
   */
  realm: string;
  /*
   * deployment id
   */
  deploymentId: string;
};

export type UpdateDeploymentByIdError = Fetcher.ErrorWrapper<undefined>;

export type UpdateDeploymentByIdVariables = {
  body: Schemas.DeploymentRepresentation;
  pathParams: UpdateDeploymentByIdPathParams;
} & DeploymentsContext['fetcherOptions'];

export const fetchUpdateDeploymentById = (variables: UpdateDeploymentByIdVariables) =>
  deploymentsFetch<
    undefined,
    UpdateDeploymentByIdError,
    Schemas.DeploymentRepresentation,
    {},
    {},
    UpdateDeploymentByIdPathParams
  >({ url: '/{realm}/deployments/{deploymentId}', method: 'put', ...variables });

export const useUpdateDeploymentById = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, UpdateDeploymentByIdError, UpdateDeploymentByIdVariables>,
    'mutationFn'
  >
) => {
  const { fetcherOptions } = useDeploymentsContext();
  return reactQuery.useMutation<undefined, UpdateDeploymentByIdError, UpdateDeploymentByIdVariables>(
    (variables: UpdateDeploymentByIdVariables) => fetchUpdateDeploymentById({ ...fetcherOptions, ...variables }),
    options
  );
};

export type DeleteDeploymentByIdPathParams = {
  /*
   * realm name (not id!)
   */
  realm: string;
  /*
   * deployment id
   */
  deploymentId: string;
};

export type DeleteDeploymentByIdError = Fetcher.ErrorWrapper<undefined>;

export type DeleteDeploymentByIdVariables = {
  pathParams: DeleteDeploymentByIdPathParams;
} & DeploymentsContext['fetcherOptions'];

export const fetchDeleteDeploymentById = (variables: DeleteDeploymentByIdVariables) =>
  deploymentsFetch<undefined, DeleteDeploymentByIdError, undefined, {}, {}, DeleteDeploymentByIdPathParams>({
    url: '/{realm}/deployments/{deploymentId}',
    method: 'delete',
    ...variables,
  });

export const useDeleteDeploymentById = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, DeleteDeploymentByIdError, DeleteDeploymentByIdVariables>,
    'mutationFn'
  >
) => {
  const { fetcherOptions } = useDeploymentsContext();
  return reactQuery.useMutation<undefined, DeleteDeploymentByIdError, DeleteDeploymentByIdVariables>(
    (variables: DeleteDeploymentByIdVariables) => fetchDeleteDeploymentById({ ...fetcherOptions, ...variables }),
    options
  );
};

export type CreateDeploymentConsoleLinkPathParams = {
  /*
   * realm name (not id!)
   */
  realm: string;
  /*
   * deployment id
   */
  deploymentId: string;
};

export type CreateDeploymentConsoleLinkError = Fetcher.ErrorWrapper<undefined>;

export type CreateDeploymentConsoleLinkVariables = {
  pathParams: CreateDeploymentConsoleLinkPathParams;
} & DeploymentsContext['fetcherOptions'];

/**
 * Create a link for this deployments admin portal. This link encodes an magic login link on behalf of the deployment's default admin user.
 */
export const fetchCreateDeploymentConsoleLink = (variables: CreateDeploymentConsoleLinkVariables) =>
  deploymentsFetch<
    Schemas.ConsoleLinkRepresentation,
    CreateDeploymentConsoleLinkError,
    undefined,
    {},
    {},
    CreateDeploymentConsoleLinkPathParams
  >({ url: '/{realm}/deployments/{deploymentId}/console-link', method: 'post', ...variables });

/**
 * Create a link for this deployments admin portal. This link encodes an magic login link on behalf of the deployment's default admin user.
 */
export const useCreateDeploymentConsoleLink = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ConsoleLinkRepresentation,
      CreateDeploymentConsoleLinkError,
      CreateDeploymentConsoleLinkVariables
    >,
    'mutationFn'
  >
) => {
  const { fetcherOptions } = useDeploymentsContext();
  return reactQuery.useMutation<
    Schemas.ConsoleLinkRepresentation,
    CreateDeploymentConsoleLinkError,
    CreateDeploymentConsoleLinkVariables
  >(
    (variables: CreateDeploymentConsoleLinkVariables) =>
      fetchCreateDeploymentConsoleLink({ ...fetcherOptions, ...variables }),
    options
  );
};

export type GetDeploymentMetricsPathParams = {
  /*
   * realm name (not id!)
   */
  realm: string;
  /*
   * deployment id
   */
  deploymentId: string;
};

export type GetDeploymentMetricsError = Fetcher.ErrorWrapper<undefined>;

export type GetDeploymentMetricsVariables = {
  pathParams: GetDeploymentMetricsPathParams;
} & DeploymentsContext['fetcherOptions'];

/**
 * Fetches metrics and health checks for the target deployment
 */
export const fetchGetDeploymentMetrics = (variables: GetDeploymentMetricsVariables) =>
  deploymentsFetch<
    Schemas.MetricsRepresentation,
    GetDeploymentMetricsError,
    undefined,
    {},
    {},
    GetDeploymentMetricsPathParams
  >({ url: '/{realm}/deployments/{deploymentId}/metrics', method: 'get', ...variables });

/**
 * Fetches metrics and health checks for the target deployment
 */
export const useGetDeploymentMetrics = (
  variables: GetDeploymentMetricsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.MetricsRepresentation, GetDeploymentMetricsError, Schemas.MetricsRepresentation>,
    'queryKey' | 'queryFn'
  >
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useDeploymentsContext(options);
  return reactQuery.useQuery<Schemas.MetricsRepresentation, GetDeploymentMetricsError, Schemas.MetricsRepresentation>(
    queryKeyFn({ path: '/{realm}/deployments/{deploymentId}/metrics', operationId: 'getDeploymentMetrics', variables }),
    () => fetchGetDeploymentMetrics({ ...fetcherOptions, ...variables }),
    {
      ...options,
      ...queryOptions,
    }
  );
};

export type QueryOperation =
  | {
      path: '/{realm}/clusters/regions';
      operationId: 'getRegions';
      variables: GetRegionsVariables;
    }
  | {
      path: '/{realm}/clusters';
      operationId: 'getClusters';
      variables: GetClustersVariables;
    }
  | {
      path: '/{realm}/clusters/{clusterId}';
      operationId: 'getClusterById';
      variables: GetClusterByIdVariables;
    }
  | {
      path: '/{realm}/clusters/{clusterId}/deployments';
      operationId: 'getDeploymentsForCluster';
      variables: GetDeploymentsForClusterVariables;
    }
  | {
      path: '/{realm}/clusters/{clusterId}/metrics';
      operationId: 'getMetricsForCluster';
      variables: GetMetricsForClusterVariables;
    }
  | {
      path: '/{realm}/clusters/{clusterId}/billing';
      operationId: 'getSubscriptionInfo';
      variables: GetSubscriptionInfoVariables;
    }
  | {
      path: '/{realm}/deployments';
      operationId: 'getDeployments';
      variables: GetDeploymentsVariables;
    }
  | {
      path: '/{realm}/deployments/name-available';
      operationId: 'checkDeploymentNameAvailable';
      variables: CheckDeploymentNameAvailableVariables;
    }
  | {
      path: '/{realm}/clusters/name-available';
      operationId: 'checkClusterNameAvailable';
      variables: CheckClusterNameAvailableVariables;
    }
  | {
      path: '/{realm}/clusters/{clusterId}/deployments/name-available';
      operationId: 'checkDedicatedClusterDeploymentNameAvailable';
      variables: CheckDedicatedClusterDeploymentNameAvailableVariables;
    }
  | {
      path: '/{realm}/deployments/{deploymentId}';
      operationId: 'getDeploymentById';
      variables: GetDeploymentByIdVariables;
    }
  | {
      path: '/{realm}/deployments/{deploymentId}/metrics';
      operationId: 'getDeploymentMetrics';
      variables: GetDeploymentMetricsVariables;
    };
